import React, { useState, useEffect } from "react";
import leftPng from "../../../../content/images/left.png";
import $ from "jquery";
import * as omnimap from "../../../../api/omnimap/omnimapActions";
import { MaatregelenEditCallBack } from "./functions/callBackFunctions";
import { StartActivity, sleep } from "../../../common/common";
import NumberInput from "../../../common/component/NumberInput/NumberInput";

const Edit = () => {
  const [selectStatEeenheid, handleSelectEeenheid] = useState(false);
  const [selectStateKwaliteit, handleSelectKwaliteit] = useState(false);

  const [selectStatuspPeriodeVoorkeur, handleSelectPeriodeVoorkeur] = useState(
    false
  );
  const [selectStatePatroonVoorkeur, handleSelectPatroonVoorkeur] = useState(
    false
  );
  const [selectStateGrootboekNummer, handleSelectGrootboekNummer] = useState(
    false
  );
  const [selectStateDiscipline, handleSelectDiscipline] = useState(false);
  const [selectStatebtwPercentage, handleSelectbtwPercentage] = useState(false);

  const handleSubmit = async () => {
    $("#cover-spin").show(0);
    var naam = $("#e-naam").val();
    var code = $("#e-code").val();
    var bestekspost = $("#e-bestekspost").val();
    var rawhoofdcode = $("#e-raw-hoofdcode").val().replaceAll(',', '.');
    var rawdeficode = $("#e-raw-deficode").val().replaceAll(',', '.');
    var eenheidsprijs = $("#e-eenheidsprijs").val().replaceAll(',', '.');
    var percentage = $("#e-percentage").val().replaceAll(',', '.');
    var eenheid = $("#e-eenheid-select").val();
    var kwaliteit = $("#e-kwaliteit-select").val();
    var omschrijving = $("#e-omschrijving").val();

    var periodeVoorkeurText = $("#e-periode-voorkeur-select").val();
    var periodeVoorkeurValue;
    document.getElementsByName("e-periode-voorkeur").forEach((element) => {
      if (element.className == "popuptext-dropdown-a-selected") {
        periodeVoorkeurValue = element.id;
      }
    });

    var patroonVoorkeurText = $("#e-patroon-voorkeur-select").val();
    var patroonVoorkeurValue;
    document.getElementsByName("e-patroon-voorkeur").forEach((element) => {
      if (element.className == "popuptext-dropdown-a-selected") {
        patroonVoorkeurValue = element.id;
      }
    });
    var disciplineText = $("#e-discipline-select").val();
    var disciplineValue;
    document.getElementsByName("e-discipline").forEach((element) => {
      if (element.className == "popuptext-dropdown-a-selected") {
        disciplineValue = element.id;
      }
    });
    var grootboekNummerText = $("#e-grootboek-nummer-select").val();
    var grootboekNummerValue;
    document.getElementsByName("e-grootboek-nummer").forEach((element) => {
      if (element.className == "popuptext-dropdown-a-selected") {
        grootboekNummerValue = element.id;
      }
    });
    var btwPercentageText = $("#e-btw-percentage-select").val();
    var BtwPercentageValue;
    document.getElementsByName("e-btw-percentage").forEach((element) => {
      if (element.className == "popuptext-dropdown-a-selected") {
        BtwPercentageValue = element.id;
      }
    });

    var id = $("#e-identification").val();
    var model = {
      content: {
        algemeen: {
          code: code,
          naam: naam,
          // actief: actief,
          eenheid: eenheid,
          rawhoofdcode: rawhoofdcode,
          kwaliteit: kwaliteit,
          bestekspost: bestekspost,
          rawdeficode: rawdeficode,
          eenheidsprijs: eenheidsprijs,
          percentage: percentage,
          omschrijving: omschrijving,
          patroonvoorkeur: patroonVoorkeurText,
          periodevoorkeur: periodeVoorkeurText,
          btwpercentage: btwPercentageText,
          patroonvoorkeurinput: {
            identification: patroonVoorkeurValue,
            display: [
              {
                path: "$.name",
                value: patroonVoorkeurText,
              },
            ],
          },
          periodevoorkeurinput: {
            identification: periodeVoorkeurValue,
            display: [
              {
                path: "$.name",
                value: periodeVoorkeurText,
              },
            ],
          },
        },
      },
      identification: id,
    };

    let isUnique = true;
    let uniqueModel = {
      content: [
        {
          and_or: "AND",
          datatype: "STRING",
          key: "algemeen-code",
          values: [code],
        },
      ],
      definitions: [process.env.REACT_APP_CATALOG_MEASURES],
      sorting: [],
    };

    //** code isunique control.
    await omnimap
      .FillTableAction(uniqueModel, 1, window.$catalog_management_units_token)
      .then(async (result) => {
        if (
          result.data &&
          result.data.length > 0 &&
          result.data[0].identification !== id
        ) {
          isUnique = await false;
          $("#cover-spin").hide(0);

          alert("code is not unique");
        }
      });

    if (isUnique) {
      omnimap
        .SaveOrEditAction(
          model,
          "PATCH",
          id,
          window.$catalog_management_units_token
        )
        .then(() => {
          MaatregelenEditCallBack(window.$catalog_management_units_token);

          if (window.$catalog_measures_discipline.definitions) {
            omnimap
              .DeleteContextAction(
                window.$catalog_measures_discipline.definitions,
                window.$catalog_management_units_token
              )
              .then(() => {
                var disciplineModel = {
                  datum: "2020-12-01T12:00:00.001Z",
                  discipline: {
                    identification: disciplineValue,
                    display: [{ path: "$.name", value: disciplineText }],
                  },
                };
                var selectedIds = [id];

                StartActivity(
                  disciplineModel,
                  selectedIds,
                  "ac2c02c3-b545-42df-88dd-16abc83c01fc",
                  "",
                  window.$catalog_management_units_token
                );
              });
          } else {
            var disciplineModel = {
              datum: "2020-12-01T12:00:00.001Z",
              discipline: {
                identification: disciplineValue,
                display: [{ path: "$.name", value: disciplineText }],
              },
            };
            var selectedIds = [id];

            StartActivity(
              disciplineModel,
              selectedIds,
              "ac2c02c3-b545-42df-88dd-16abc83c01fc",
              "",
              window.$catalog_management_units_token
            );
          }

          if (window.$catalog_measures_grootboek_nummer.definitions) {
            omnimap
              .DeleteContextAction(
                window.$catalog_measures_grootboek_nummer.definitions,
                window.$catalog_management_units_token
              )
              .then(() => {
                var grootboeknummerModel = {
                  grootboeknummer: grootboekNummerValue,
                };
                var selectedIds = [id];

                sleep(2000).then(() => {
                  StartActivity(
                    grootboeknummerModel,
                    selectedIds,
                    "4b2b5976-21e5-4810-8f58-adf0e8ecf481",
                    "",
                    window.$catalog_management_units_token
                  );
                });

                // var disciplineModel = {
                //   datum: "2020-12-01T12:00:00.001Z",
                //   discipline: {
                //     identification: disciplineValue,
                //     display: [{ path: "$.name", value: disciplineText }],
                //   },
                // };
                // var selectedIds = [id];

                // StartActivity(
                //   disciplineModel,
                //   selectedIds,
                //   "ac2c02c3-b545-42df-88dd-16abc83c01fc",
                //   "",
                //   window.$catalog_management_units_token
                // );
              });
          } else {
            var grootboeknummerModel = {
              grootboeknummer: grootboekNummerValue,
            };
            var selectedIds = [id];

            sleep(2000).then(() => {
              StartActivity(
                grootboeknummerModel,
                selectedIds,
                "4b2b5976-21e5-4810-8f58-adf0e8ecf481",
                "",
                window.$catalog_management_units_token
              );
            });
          }
        });
    }
  };

  useEffect(() => {
    $(document).on("click", ".popuptext-dropdown-a", function () {
      $("#" + $(this).attr("name") + "-select").val($(this).text());
      $("#" + $(this).attr("name") + "-select");
      var test = $("#" + $(this).attr("name"));
      test[0].childNodes.forEach((element) => {
        element.className = "popuptext-dropdown-a";
      });
      $(this).attr("class", "popuptext-dropdown-a-selected");

      if ($(this).attr("name") === "e-eenheid") {
        handleSelectEeenheid(!selectStatEeenheid);
      }
      if ($(this).attr("name") === "e-kwaliteit") {
        handleSelectKwaliteit(!selectStateKwaliteit);
      }
      if ($(this).attr("name") === "e-periode-voorkeur") {
        handleSelectPeriodeVoorkeur(!selectStatuspPeriodeVoorkeur);
      }
      if ($(this).attr("name") === "e-patroon-voorkeur") {
        handleSelectPatroonVoorkeur(!selectStatePatroonVoorkeur);
      }
      if ($(this).attr("name") === "e-grootboek-nummer") {
        handleSelectGrootboekNummer(!selectStateGrootboekNummer);
      }
      if ($(this).attr("name") === "e-discipline") {
        handleSelectDiscipline(!selectStateDiscipline);
      }
      if ($(this).attr("name") === "e-btw-percentage") {
        handleSelectDiscipline(!selectStatebtwPercentage);
      }
    });
    /*** ---BAŞLANGIÇ TARİHİ DEĞİŞTİĞİNDE, BİTİŞ TARİHİNİN BAŞLANGIÇ TARİHİNDEN KÜÇÜK OLMAMASINI CONTROL EDER--- ***/
    $("#e-startDate").change(function () {
      if (this.value > $("#e-endDate").val()) {
        $("#e-endDate").val(this.value);
      }
      $("#e-endDate").attr("min", this.value);
    });
  });

  return (
    <div id="editSide" className="d-none">
      <div className="detail-title">Maatregelen in detail</div>
      <div className="clearfix">
        <div className="float-left mt-4">
          <a id="detail-button" className="back-page-link" role="button">
            <img src={leftPng} width={9} height={12} /> &nbsp;Terug naar
            Maatregelen
          </a>
        </div>
        <div className="float-right mt-0">
          <a id="edit_maatregelen" className="button ok" onClick={handleSubmit}>
            Opslaan
          </a>
        </div>
        <div className="float-right mt-0 w-20">
          <a id="return-detail" className="button back">
            Annuleren
          </a>
        </div>
      </div>
      <div className="row clearfix">
        <div className="col-lg-4 text-center">
          <div className="box-detail-active">
            <div className="box-title-1-active">Naam</div>
            <div className="box-title-2-active">
              <input id="e-naam" />
            </div>
          </div>
        </div>
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Code</div>
            <div className="box-title-2">
              <input id="e-code" />
            </div>
          </div>
        </div>
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Bestekspost</div>
            <div className="box-title-2">
              <input id="e-bestekspost" />
            </div>
          </div>
        </div>
      </div>

      <div className="row clearfix">
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">RAW Hoofdcode</div>
            <div className="box-title-2">
              <NumberInput id="e-raw-hoofdcode" type="number"/>
            </div>
          </div>
        </div>
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">RAW Deficode</div>
            <div className="box-title-2">
              <NumberInput id="e-raw-deficode" type="number" />
            </div>
          </div>
        </div>
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Eenheidsprijs</div>
            <div className="box-title-2">
              <NumberInput id="e-eenheidsprijs" type="text" />
            </div>
          </div>
        </div>
      </div>
      <div className="row clearfix">
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Eenheid</div>
            <div
              className={
                selectStatEeenheid
                  ? "box-title-2 select-content open"
                  : "box-title-2 select-content"
              }
              onClick={() => handleSelectEeenheid(!selectStatEeenheid)}
            >
              <input
                id="e-eenheid-select"
                type="button"
                className="edit-dropdown"
              />
              <div class="popup-dropdown">
                <span
                  className={
                    selectStatEeenheid
                      ? "popuptext-dropdown show"
                      : "popuptext-dropdown"
                  }
                  id="e-eenheid"
                ></span>
              </div>

              {/* <select class="form-control" id="e-eenheid" hidden></select> */}
            </div>
          </div>
        </div>
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Percentage</div>
            <div className="box-title-2">
              <NumberInput id="e-percentage" type="number" />
            </div>
          </div>
        </div>
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Kwaliteit</div>
            <div className="box-title-2">
              <div
                className={
                  selectStateKwaliteit
                    ? "box-title-2 select-content open"
                    : "box-title-2 select-content"
                }
                onClick={() => handleSelectKwaliteit(!selectStateKwaliteit)}
              >
                <input
                  id="e-kwaliteit-select"
                  type="button"
                  className="edit-dropdown"
                />
                <div class="popup-dropdown">
                  <span
                    className={
                      selectStateKwaliteit
                        ? "popuptext-dropdown show"
                        : "popuptext-dropdown"
                    }
                    id="e-kwaliteit"
                  ></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row clearfix">
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Omschrijving</div>
            <div className="box-title-2">
              <input id="e-omschrijving" />
            </div>
          </div>
        </div>
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Periode voorkeur</div>
            <div
              className={
                selectStatuspPeriodeVoorkeur
                  ? "box-title-2 select-content open"
                  : "box-title-2 select-content"
              }
              onClick={() =>
                handleSelectPeriodeVoorkeur(!selectStatuspPeriodeVoorkeur)
              }
            >
              <input
                id="e-periode-voorkeur-select"
                type="button"
                className="edit-dropdown"
              />
              <div class="popup-dropdown">
                <span
                  className={
                    selectStatuspPeriodeVoorkeur
                      ? "popuptext-dropdown show"
                      : "popuptext-dropdown"
                  }
                  id="e-periode-voorkeur"
                ></span>
              </div>

              {/* <select class="form-control" id="e-eenheid" hidden></select> */}
            </div>
          </div>
        </div>

        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Patroon voorkeur</div>
            <div
              className={
                selectStatePatroonVoorkeur
                  ? "box-title-2 select-content open"
                  : "box-title-2 select-content"
              }
              onClick={() =>
                handleSelectPatroonVoorkeur(!selectStatePatroonVoorkeur)
              }
            >
              <input
                id="e-patroon-voorkeur-select"
                type="button"
                className="edit-dropdown"
              />
              <div class="popup-dropdown">
                <span
                  className={
                    selectStatePatroonVoorkeur
                      ? "popuptext-dropdown show"
                      : "popuptext-dropdown"
                  }
                  id="e-patroon-voorkeur"
                ></span>
              </div>

              {/* <select class="form-control" id="e-eenheid" hidden></select> */}
            </div>
          </div>
        </div>
      </div>
      <div className="row clearfix">
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Grootboek nummer</div>
            <div
              className={
                selectStateGrootboekNummer
                  ? "box-title-2 select-content open"
                  : "box-title-2 select-content"
              }
              onClick={() =>
                handleSelectGrootboekNummer(!selectStateGrootboekNummer)
              }
            >
              <input
                id="e-grootboek-nummer-select"
                type="button"
                className="edit-dropdown"
              />
              <div class="popup-dropdown">
                <span
                  className={
                    selectStateGrootboekNummer
                      ? "popuptext-dropdown show"
                      : "popuptext-dropdown"
                  }
                  id="e-grootboek-nummer"
                ></span>
              </div>

              {/* <select class="form-control" id="e-eenheid" hidden></select> */}
            </div>
          </div>
        </div>

        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">Discipline</div>
            <div
              className={
                selectStateDiscipline
                  ? "box-title-2 select-content open"
                  : "box-title-2 select-content"
              }
              onClick={() => handleSelectDiscipline(!selectStateDiscipline)}
            >
              <input
                id="e-discipline-select"
                type="button"
                className="edit-dropdown"
              />
              <div class="popup-dropdown">
                <span
                  className={
                    selectStateDiscipline
                      ? "popuptext-dropdown show"
                      : "popuptext-dropdown"
                  }
                  id="e-discipline"
                ></span>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-4 text-center">
          <div className="box-detail">
            <div className="box-title-1">BTW percentage</div>
            <div
              className={
                selectStatebtwPercentage
                  ? "box-title-2 select-content open"
                  : "box-title-2 select-content"
              }
              onClick={() =>
                handleSelectbtwPercentage(!selectStatebtwPercentage)
              }
            >
              <input
                id="e-btw-percentage-select"
                type="button"
                className="edit-dropdown"
              />
              <div class="popup-dropdown">
                <span
                  className={
                    selectStatebtwPercentage
                      ? "popuptext-dropdown show"
                      : "popuptext-dropdown"
                  }
                  id="e-btw-percentage"
                ></span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <input hidden id="e-identification" />
    </div>
  );
};

export default Edit;
